import {} from './actions';

const initialState = {};

export const createPromoCodeReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};
